module.exports = __webpack_public_path__ + "static/img/去挂号@3x.48ab067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/去挂号@3x.png
// module id = 774
// module chunks = 358